export default __webpack_public_path__ + "static/media/dds5168_4p.be30f1a5.png";